export default __webpack_public_path__ + "static/media/ThaiSansNeue-Regular.394a4efc.ttf";